import React, { useEffect } from 'react';
import { remoteBacklogStore, useRemoteBacklogNavState } from '../../utils/remoteBacklogStore';
import './RemoteBacklogNavButton.css';

/** 상단 네비: 남은 메시지(리모컨 공지/질문) 다시 열기 — 남은 항목이 있을 때만 표시 */
const RemoteBacklogNavButton: React.FC<{ variant?: 'icon' | 'clock' }> = ({ variant = 'icon' }) => {
  const { active, count, collapsed } = useRemoteBacklogNavState();
  useEffect(() => remoteBacklogStore.registerNavButton(), []);
  /* 프레젠테이션(수신 측)에서만 표시 — 미확인 0이면 회색·배지 없음 */
  if (!active) return null;
  const has = count > 0;
  return (
    <button
      type="button"
      className={`${variant === 'clock' ? 'cp-remote-bl-navbtn is-clock' : 'cp-mail-icon-btn cp-remote-bl-navbtn'}${has ? ' has-unread' : ' is-empty'}${has && collapsed ? ' is-ringing' : ''}`}
      onClick={() => remoteBacklogStore.expand()}
      title="남은 메시지"
      aria-label={has ? `남은 메시지 (미확인 ${count}건)` : '남은 메시지'}
    >
      <svg className="cp-mail-icon-btn-svg cp-remote-bl-navbtn-svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
          d="M4 4.5h12a1.5 1.5 0 0 1 1.5 1.5v6.5A1.5 1.5 0 0 1 16 14H9l-3.5 3v-3H4a1.5 1.5 0 0 1-1.5-1.5V6A1.5 1.5 0 0 1 4 4.5z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <circle cx="7" cy="9.25" r=".9" fill="currentColor" />
        <circle cx="10" cy="9.25" r=".9" fill="currentColor" />
        <circle cx="13" cy="9.25" r=".9" fill="currentColor" />
      </svg>
      {has ? (
        <span className="cp-mail-icon-badge" aria-hidden="true">
          {count > 99 ? '99+' : count}
        </span>
      ) : null}
    </button>
  );
};

export default RemoteBacklogNavButton;
